import React from 'react';
import { Hero } from '../components/Hero';
import { ProjectShowcase } from '../components/ProjectShowcase';
import { FAQSection } from '../components/FAQSection';
import { SchemaMarkup } from '../components/SchemaMarkup';
export function Portfolio() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#0ea5e9] selection:text-white" data-id="element-170">
      <SchemaMarkup data-id="element-171" />

      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-md border-b border-[#1a1a1a]" data-id="element-172">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
          <div className="flex items-center justify-between h-16" data-id="element-174">
            <div className="flex-shrink-0 font-bold text-2xl tracking-tighter" data-id="element-175">
              REX<span className="text-[#0ea5e9]" data-id="element-176">.</span>
            </div>
            <div className="hidden md:block" data-id="element-177">
              <div className="ml-10 flex items-baseline space-x-8" data-id="element-178">
                <a href="#" className="text-white hover:text-[#0ea5e9] px-3 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-179">
                  Home
                </a>
                <a href="#" className="text-gray-300 hover:text-[#0ea5e9] px-3 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-180">
                  Services
                </a>
                <a href="#" className="text-gray-300 hover:text-[#0ea5e9] px-3 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-181">
                  Portfolio
                </a>
                <a href="#" className="text-gray-300 hover:text-[#0ea5e9] px-3 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-182">
                  FAQ
                </a>
              </div>
            </div>
            <div data-id="element-183">
              <a href="https://wa.me/923112148225" target="_blank" rel="noopener noreferrer" className="bg-[#0ea5e9] hover:bg-[#0284c7] text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors" data-id="element-184">
                Get Quote
              </a>
            </div>
          </div>
        </div>
      </nav>

      <main data-id="element-185">
        <Hero data-id="element-186" />
        <ProjectShowcase data-id="element-187" />

        {/* Services / Features Grid could go here */}

        <FAQSection data-id="element-188" />
      </main>

      <footer className="bg-[#050505] border-t border-[#1a1a1a] py-12" data-id="element-189">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-191">
            <div className="col-span-1 md:col-span-2" data-id="element-192">
              <h3 className="text-2xl font-bold mb-4" data-id="element-193">
                REX<span className="text-[#0ea5e9]" data-id="element-194">.</span>
              </h3>
              <p className="text-gray-400 max-w-xs" data-id="element-195">
                UK Based Web Design and Mobile App Development Company. Crafting
                digital excellence since 2020.
              </p>
            </div>
            <div data-id="element-196">
              <h4 className="text-white font-semibold mb-4" data-id="element-197">Services</h4>
              <ul className="space-y-2 text-gray-400 text-sm" data-id="element-198">
                <li data-id="element-199">Web Design</li>
                <li data-id="element-200">Mobile Apps</li>
                <li data-id="element-201">E-commerce</li>
                <li data-id="element-202">SEO Optimization</li>
              </ul>
            </div>
            <div data-id="element-203">
              <h4 className="text-white font-semibold mb-4" data-id="element-204">Contact</h4>
              <ul className="space-y-2 text-gray-400 text-sm" data-id="element-205">
                <li data-id="element-206">London, UK</li>
                <li data-id="element-207">+92 311 2148225</li>
                <li data-id="element-208">hello@rextechnologies.co.uk</li>
              </ul>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-[#1a1a1a] text-center text-gray-500 text-sm" data-id="element-209">
            © {new Date().getFullYear()} Rex Technologies. All rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}